
const assert = require('assert');

const _ = require('lodash');

import ko from 'rgs-knockout';

const Q = require('q');

const $ = require('jquery');

const Velocity = (function (Velocity) {
	return function VelocityPromiseWrapper (...args) {
		// WORKAROUND: https://github.com/julianshapiro/velocity/issues/771
		const [ elems ] = args;
		if ($(elems).length === 0) {
			return Q.resolve();
		}

		const promise = Velocity(...args);
		assert(Q.isPromiseAlike(promise), 'Velocity must return a promise-like object');
		return Q(promise);
	};
}(require('rgs-velocity-animate')));

const SinglePromiseQueue = require('single-promise-queue');

const VELOCITY_TIMEOUT_MESSAGE = 'VELOCITY_TIMEOUT';

function hide ($el) {
	return Velocity($el, 'slideUp')
		.catch(e => {
			if (e.message.startsWith('Velocity:')) {
				console.warn(e);
				return $el.hide();
			}
			throw e;
		});
}

function show ($el) {
	return Velocity($el, 'slideDown')
		.catch(e => {
			if (e.message.startsWith('Velocity:')) {
				console.warn(e);
				return $el.show();
			}
			throw e;
		});
}

function transitionFromStepOpenToStepSummary ({ $summary, $body }) {
	const $hiddenRows = $summary
		  .find('.summary-row')
		  .css('visibility', 'hidden');
	let $animatedRows;

	return Q.all([
		hide($body),
		show($summary)
			.then(function () {
				$hiddenRows.css('visibility', 'visible');
				$animatedRows = $summary.find('.summary-row:visible');
				return Velocity($animatedRows, 'transition.slideRightIn', {
					stagger: 200,
				});
			})

		// WORKAROUND: https://github.com/julianshapiro/velocity/issues/825
			.timeout(5000, VELOCITY_TIMEOUT_MESSAGE)
			.catch(e => {
				if (e.message !== VELOCITY_TIMEOUT_MESSAGE) {
					throw e;
				}

				console.warn('Step summary animation timed out:', e);

				const removedAnimatedRows = _.filter($animatedRows.toArray(), e => {
					return !$.contains($summary[0], e);
				});

				if (!_.isEmpty(removedAnimatedRows)) {
					console.warn(
						'Following animated elements were removed during animation',
						removedAnimatedRows,
						'Please try to avoid DOM element removal inside step-summary',
						'during step animations.',
						'More info: https://github.com/julianshapiro/velocity/issues/825',
					);
				}
			}),
	]);
}

ko.bindingHandlers.steps__stepStateTransitions = {
	init: function (element, valueAccessor) {
		const $step = $(element);
		const $body = $step.children('.step-body');
		const $summary = $step.children('.step-summary');

		const state = ko.pureComputed(() => {
			const flags = ko.unwrap(valueAccessor());

			if (flags.isCurrent) {
				return 'open-body';
			}
			if (flags.isEdited) {
				return 'open-summary';
			}
			return 'close';
		}, null, { disposeWhenNodeIsRemoved: element });

		function getOptions () {
			return _.mapValues(_.defaults({}, ko.unwrap(valueAccessor())), (v) => ko.unwrap(v));
		}

		function scrollToStepTop ($step, shouldScroll) {
			return shouldScroll ? Velocity($step, 'scroll') : null;
		}

		function transitionImmediate (oldState, targetState, isInitial) {
			if (!isInitial && oldState === targetState) {
				return _.noop();
			}
			const options = getOptions();

			return ({
				'open-body': () => {
					$body.show();
					$summary.hide();
					scrollToStepTop($step, options.scroll);
				},
				'open-summary': () => {
					$body.hide();
					$summary.show();
				},
				'close': () => {
					$body.hide();
					$summary.hide();
				},
			})[targetState]();
		}

		function transitionAnimated (oldState, targetState) {
			const options = getOptions();

			return Q(({
				'open-body': {
					'open-body': _.noop,
					'open-summary': () => transitionFromStepOpenToStepSummary({
						$summary,
						$body,
					}),
					'close': () => hide($body),
				},

				'open-summary': {
					'open-body': () => Q.all([
						hide($summary),
						show($body),
					])
						.delay(250)
						.then(() => scrollToStepTop($step, options.scroll)),
					'open-summary': _.noop,
					'close': () => hide($summary),
				},

				'close': {
					'open-body': () => show($body)
							.then(() => scrollToStepTop($step, options.scroll)),
					'open-summary': () => show($summary),
					'close': _.noop,
				},
			})[oldState][targetState]());
		}

		let previousReachedState = 'close';
		const transitionsQueue = new SinglePromiseQueue();
		let initialRun = true;
		ko.computed(() => {
			const targetState = state();
			const { isAnimated } = getOptions();

			ko.ignoreDependencies(() => {
				if (initialRun || !isAnimated) {
					transitionImmediate(previousReachedState, targetState, initialRun);
					initialRun = false;
					previousReachedState = targetState;
					return;
				}

				transitionsQueue.push(() => transitionAnimated(previousReachedState, targetState)
					.finally(() => {
						previousReachedState = targetState;
					})
				).done();
			});
		}, null, { disposeWhenNodeIsRemoved: element }).extend({
			rateLimit: {
				timeout: 300,
				method: 'notifyWhenChangesStop',
			},
		});
	},
};


